import React from 'react';
import { string, shape, boolean } from 'prop-types';

export default function ContentTile({ item }) {
    const frameless = item.frameless ? ' frameless' : '';
    const inverse = item.inverse ? ' inverse' : '';
    const hasCta = item.cta ? ' has-cta' : '';

    return (
        <div className={`c-tile c-card-tile${frameless}${inverse}`}>
            <p className="date">
                <a href={`/year=${item.year}`}>{item.date}</a>
                {item.location &&
                    <strong> - <a href={`/location=${item.location}`}>{item.location}</a></strong>
                }
            </p>

            {item.highlight &&
                <h2><a href={item.highlightUrl}>{item.highlight}</a></h2>
            }

            {item.smallTitle &&
                <h4><a href={item.url}>{item.title}</a></h4>
            }

            {item.smallTitle ||
                <h3><a href={item.url}>{item.title}</a></h3>
            }

            {item.hashtag &&
                <p className="hashtag"><a href={item.hashtagUrl}>{item.hashtag}</a></p>
            }

            <p className={`summary${hasCta}`}>{item.paragraph}</p>

            {item.cta &&
                <h5><a href={item.ctaUrl}>{item.cta}</a></h5>
            }
        </div>
    );
}

ContentTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        frameless: boolean,
        inverse: boolean,
        smallTitle: boolean,
        date: string.isRequired,
        year: string.year,
        title: string.isRequired,
        paragraph: string.isRequired,
        url: string.isRequired,
        location: string,
        highlight: string,
        highlightUrl: string,
        hashtag: string,
        hashtagUrl: string,
        cta: string,
        ctaUrl: string
    }).isRequired
    /* eslint-enable react/no-typos */
};



// WEBPACK FOOTER //
// ./src/components/tiles/CardTile.jsx